import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { getModeFontSize } from '../../services/stringServices';

const useStyles = makeStyles(() => ({
  modeText: {
    fontSize: "15px",
    lineHeight: "1.1",
    textAlign: "center",
    overflowWrap: "normal",
    wordBreak: "normal",
    maxHeight: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 4px",
    boxSizing: "border-box",
    whiteSpace: "normal",
    overflow: "hidden",
  },
}));

interface ModeTextProps {
  text: string;
  color?: string;
  className?: string;
}

/**
 * ModeText component for rendering operation mode labels with dynamic font size.
 * It uses getModeFontSize to adjust the font size based on text length to prevent overflow.
 *
 * @param {ModeTextProps} props - The props for the component.
 * @param {string} props.text - The text to display (e.g., "COOL", "HAUX").
 * @param {string} [props.color] - Optional color override (e.g., "rgb(240, 81, 70)").
 * @param {string} [props.className] - Optional CSS class for additional styling.
 *
 * @example
 * <ModeText text="HAUX" color="rgb(240, 81, 70)" />
 * 
 * @example
 * <ModeText text={modeTypes[mode]} />
 */
const ModeText: React.FC<ModeTextProps> = ({ text, color, className }) => {
  const classes = useStyles();
  return (
    <Typography
      className={clsx(classes.modeText, className)}
      style={{ 
        ...(color ? { color } : {}), 
        fontSize: getModeFontSize(text) 
      }}
    >
      {text}
    </Typography>
  );
};

export default ModeText;
